import { Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../../../AccessControl/AccessControlTypes';
import { Data } from '@singularsystems/neo-core';
import ProvisionalTaxReportsSearchCriteria from '../Models/Queries/ProvisionalTaxReportsSearchCriteria';
import DividendTransactionsLookup from '../Models/Lookups/DividendTransactionsLookup';

export default class DividendTransactionsVM extends Views.ViewModelBase {
    public provisionalTaxReportsSearchCrtieria: ProvisionalTaxReportsSearchCriteria = new ProvisionalTaxReportsSearchCriteria();
    public dividendTransactionsPageManager = new Data.PageManager(this.provisionalTaxReportsSearchCrtieria, DividendTransactionsLookup,
       this.provisionalTaxReportsApiClient.getDividendTransactionsPagedList, {
          pageSize: 10, 
          sortAscending: true,
          fetchInitial: false,
          sortBy: "eventDate",
          initialTaskRunner: this.taskRunner,
       }
     );
      constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),        
        private notifications = AppService.get(Types.Neo.UI.GlobalNotifications),
        private provisionalTaxReportsApiClient = AppService.get(Types.ApiClients.ProvisionalTaxReportsApiClient)) {
        super(taskRunner);
      } 

    public async initialise() {
    }
    
    public search(searchCriteria: ProvisionalTaxReportsSearchCriteria) {
        this.provisionalTaxReportsSearchCrtieria.mapFrom(searchCriteria);   
    }
}